import axios from "axios";
import { inject, injectable } from "inversify";
import { IEntitlementsRepository } from "@domain/repositories";
import type { Entitlement, EntitlementsResponse } from "@domain/schemas/BI";
import { API_ENDPOINTS } from "@infrastructure/InfrastructureConstants";
import { runtimeConfig } from "@utils/runtimeConfig/runtimeConfig";
import { TYPES } from "@utils/inversifyJS/types";
import type { IAuthenticatedRequestHandlerService } from "@application/contracts/services";

@injectable()
export class EntitlementsRepository implements IEntitlementsRepository {
  @inject(TYPES.IAuthenticatedRequestHandlerService)
  private _requestHandlerService!: IAuthenticatedRequestHandlerService;

  public async getEntitlementsAsync(): Promise<Entitlement[]> {
    const url = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.entitlements}`;
    const response = await this._requestHandlerService.handleRequestAsync<EntitlementsResponse>(() => axios.get<EntitlementsResponse>(url));
    return response.entitlements ?? [];
  }
}
